import {Component, Inject, OnInit} from '@angular/core';
import {
  AbstractControl, UntypedFormBuilder,
  FormControl,
  UntypedFormGroup,
  ValidationErrors,
  Validator,
  ValidatorFn,
  Validators
} from "@angular/forms";
import {AuthService} from "../auth/auth.service";
import {Router} from "@angular/router";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {

  user: any
  errorMessage: string | undefined
  form: UntypedFormGroup;

  constructor(
    private router: Router,
    private auth: AuthService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ChangePasswordComponent>,
    private fb: UntypedFormBuilder
  ) {
    this.user = data
    this.form = this.fb.group({
      password: ['', [Validators.required]],
      confirmPassword: ['']
    }, { validators: this.checkPasswords })
  }

  ngOnInit(): void {}

  checkPasswords: ValidatorFn = (group: AbstractControl):  ValidationErrors | null => {
    let pass = group.get('password')?.value;
    let confirmPass = group.get('confirmPassword')?.value
    return pass === confirmPass ? null : { notSame: true }
  }

  completeNewPassword() {
    this.auth.completeNewPassword(this.user, this.form.get('password')?.value).subscribe(
      (user) => {
        this.router.navigate(['/upload']);
        this.dialogRef.close()
      },
      (error) => {
        this.form.get('password')?.reset()
        this.form.get('confirmPassword')?.reset()
        this.errorMessage = error.message
      }
    )
  }
}
